import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { RELATIVE_CONDITION_INDEX_GRAPH } from './url-constants';

type RelativeIndexEndpointSpecification = ApiEndpointSpecification;
export const RelativeIndexEndpointSpecification: RelativeIndexEndpointSpecification = {
    url:RELATIVE_CONDITION_INDEX_GRAPH,
    method:HttpMethod.POST,
    requestParamsSchemaName: 'ConditionIndexRequestParams',
    requestBodySchemaName: 'CondtionIndexRequestBody',
    okResponseSchemaName: 'ConditionIndexOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2.0
};

export const invokeRelativeIndexApiData = Helpers.makeApiRequestFn<
Types.ConditionIndexRequestParams,
Types.ConditionIndexRequestBody,
Types.CondtionIndexOkresponse
>(RelativeIndexEndpointSpecification);
